import React from "react";

export default (props: React.SVGAttributes<SVGElement>) =>
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000" {...props}><path d="M3 4.6h18V7H3zM3 10.8h13v2.4H3zM3 17h8v2.4H3z"/></svg>;
